enum RoleType {
  User,
  Admin,
}

export default RoleType;
